import angular = require("angular");
import TPL = require("templates");

export class NotificationDirective {

  template = TPL.contentDirectives.notification;
  scope = {
    params:"=params"
  };

  constructor() {}

  static factory() {
    var tmp = () => new NotificationDirective();
    return tmp;
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/content/notification.ts
 **/